export default "__VITE_ASSET__FaIHUNZF__"